import { fetchApi } from '@/config/api'
import type { 
  BlockedBuyer, 
  BuyerAutocomplete, 
  BlockBuyerInput 
} from '@/types/blockedBuyer'

/**
 * Récupère la liste des acheteurs bloqués par le vendeur connecté
 */
export async function getBlockedBuyers(): Promise<BlockedBuyer[]> {
  const query = `
    query GetBlockedBuyers {
      blockedBuyers {
        id_vendeur_acheteur_disabled
        id_acheteur
        date_disabled
        acheteur {
          nomSociete
          email
        }
      }
    }
  `

  const result = await fetchApi<{ blockedBuyers: BlockedBuyer[] }>(query)
  return result.blockedBuyers
}

/**
 * Recherche des acheteurs pour l'autocomplétion (pour blocage)
 */
export async function searchBuyersForBlocking(term: string): Promise<BuyerAutocomplete[]> {
  const query = `
    query SearchBuyers($term: String!) {
      searchBuyers(term: $term) {
        id
        label
        desc
        email
      }
    }
  `

  const result = await fetchApi<{ searchBuyers: BuyerAutocomplete[] }>(query, { term })
  return result.searchBuyers
}

/**
 * Bloque un acheteur
 */
export async function blockBuyer(idAcheteur: number): Promise<boolean> {
  const query = `
    mutation BlockBuyer($input: BlockBuyerInput!) {
      blockBuyer(input: $input)
    }
  `

  const input: BlockBuyerInput = { id_acheteur: idAcheteur }
  const result = await fetchApi<{ blockBuyer: boolean }>(query, { input })
  return result.blockBuyer
}

/**
 * Débloque un acheteur
 */
export async function unblockBuyer(id: number): Promise<boolean> {
  const query = `
    mutation UnblockBuyer($id: Int!) {
      unblockBuyer(id: $id)
    }
  `

  const result = await fetchApi<{ unblockBuyer: boolean }>(query, { id })
  return result.unblockBuyer
}

